// extracted by mini-css-extract-plugin
module.exports = {"regis-info":"registrationInfo_regis-info__3mk2S"};